import(/* webpackMode: "eager" */ "/vercel/path0/src/app/problems/page.tsx");
